import React from 'react';
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
// components
import { Link, Stack, Typography, Theme } from '@mui/material';
import AuthButton from './AuthButton';

// icons
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const ICON_MAP = {
  home: HomeOutlinedIcon,
  feedback: AnnouncementOutlinedIcon,
  tutorials: VideoLibraryOutlinedIcon,
  help: ContactSupportOutlinedIcon
};

const NavText = styled(Typography)(({theme}) => ({
  color: 'rgba(255, 255, 255, 0.70)',
  fontFamily: 'Inter',
  fontSize: '12px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal',
}));

const styles = makeStyles((theme: Theme) => createStyles({
  root: {
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid #1C1C1C',
      flexDirection: 'column',
    },
    '& a': {
      textDecoration: 'none'
    }
  },
  navItem: {
    columnGap: '8px',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      width: '100%',
      padding: '15px'
    }
  }
}));

const SecondaryNav = ({navItems, league}) => {
  const location = useLocation();
  const classes = styles();
  
  return (
    <Stack className={classes.root}>
      {
        navItems && navItems.map(item => {
          const { name, label } = item;
          const IconComponent = ICON_MAP?.[label] || null;
          const isSingleLineupSim = location?.pathname?.toLowerCase()?.includes('singlelineupsim');
          let link = item?.link;
          link = (label ==='feedback' && isSingleLineupSim) ? 'https://www.stokastic.com/single-lineup-simulator-feedback/' 
            : (label ==='feedback' && !isSingleLineupSim) ? `/postcontestsimulator/${league}/feedback`
              : link;

          return (
            <Link href={link} target='_blank' key={label}>
              <Stack className={classes.navItem}>
                <NavText variant='subtitle1'>
                  { name }
                </NavText>
                { IconComponent && <IconComponent sx={{color: 'rgba(255, 255, 255, 0.70)', height: 24, width: 24 }} /> }
              </Stack>
            </Link>
            )
          })
        }
      <AuthButton />
    </Stack>
  )
}

export default SecondaryNav;